<template>
  <div v-if="config && config.sectionName">
    <div class="breadLine">
      <div class="bc" v-if="config.navigation && config.navigation.length > 0">
        <ul id="breadcrumbs" class="breadcrumbs">
          <li><router-link tag="a" :to="{ name: 'system' }"><i class="fas fa-home"></i> Home</router-link></li>
          <li v-for="(nav, key) in config.navigation" :key="key" :class="{ 'current': config.navigation.length - 1 == key }">
            <router-link tag="a" :to="{ name: nav.route }">{{nav.name}}</router-link>
          </li>
        </ul>
      </div>

      <div class="breadLinks" v-if="config.buttons && config.buttons.length > 0">
        <ul>
          <li v-for="(button, key) in config.buttons" :key="key">
            <a title v-if="button != null" @click="button.action" >
              <i :class="button.icon" class="mr-1"></i> <span>{{ button.name }}</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PageHeading',
  props: {
    config: Object,
  },
}
</script>
<style scoped>
.md-theme-default a:not(.md-button) { color: #fff !important;}
/* === Breadcrumbs line === */

.breadLine { clear: both; height: 28px; /*box-shadow: 0 1px 0 #fff, 0 1px 0 #fff inset;*/ background: #3e4c5f; border-top: 1px solid #333; border-bottom: 1px solid #c3c3c3; font-size: 11px; }
.breadLine .hideArrow { width: 30px; float: left; background-position: 12px 10px; padding: 14px 0 14px 0; border-right: 1px solid #c3c3c3; }
.breadLine .hideArrow:hover { background-color: #f5f5f5; }

/* Breadcrumbs */

.bc { margin: 0; float: left; }
ul.breadcrumbs { position: relative; z-index: 990; margin-left: 18px; }
ul.breadcrumbs:after { content: ""; display: block; clear: both; }
ul.breadcrumbs li { float: left; position: relative; }
ul.breadcrumbs li.current { border-right: none; }
ul.breadcrumbs li a { color: #666666; text-decoration: none; padding: 0px 20px 0px 14px; display: block; background: url('../assets/images/icons/breadsArrow.png') no-repeat 100% 10px; height: 22px; line-height: 23px; }
ul.breadcrumbs li a:hover, ul.breadcrumbs li.hover a { color: #2B6893; }

ul.breadcrumbs > li:not(.current)::after {   content: '';
	position: absolute;
	right: 0px;
	top: 9px;
	width: 0;
	height: 0;
	border-style: solid;
	border-width: 4px 0 4px 6px;
	border-color: transparent transparent transparent #ddd;
	clear: both;}

ul.breadcrumbs, ul.breadcrumbs li, ul.breadcrumbs li a { height: 100%; line-height: 26px; }

ul.breadcrumbs > li:first-child > a { padding-left: 20px; }
ul.breadcrumbs li.current > a { color: #B1B1B1; background: none; }
ul.breadcrumbs li ul { position: absolute; background: url('../assets/images/subArrow.png') no-repeat 10px 5px; font-size: 11px; width: 160px; top: 28px; padding-top: 10px; margin-left: 12px; display: none; }
ul.breadcrumbs li ul li { width: 180px; border-bottom: 1px solid #343434; text-align: left; border-top: 1px solid #545454; background: url('../assets/images/backgrounds/sidebar.jpg'); padding: 0; float: none; }
ul.breadcrumbs li ul li:first-child { -webkit-border-top-right-radius: 2px; -webkit-border-top-left-radius: 2px; -moz-border-radius-topright: 2px; -moz-border-radius-topleft: 2px; border-top: none; padding-top: 1px; }
ul.breadcrumbs li ul li:last-child { -webkit-border-bottom-right-radius: 2px; -webkit-border-bottom-left-radius: 2px; -moz-border-radius-bottomright: 2px; -moz-border-radius-bottomleft: 2px; }
ul.breadcrumbs li ul li:hover {  }
ul.breadcrumbs li ul li a { text-decoration: none; padding: 5px 14px 5px 24px; color: #CCCCCC !important; display: block; background: url('../assets/images/elements/control/subnav_arrow.png') no-repeat 12px 13px; }
ul.breadcrumbs li ul li a:hover { background-color: #454545 }
.md-theme-default ul.breadcrumbs li ul li a:not(.md-button) { color: #dedcdc; }

/* Breadlinks */

.breadLinks { float: right; margin-right: 22px; height: 100%; }
.breadLinks, .breadLinks ul, .breadLinks ul li, .breadLinks ul li a { height: 100%; line-height: 26px;}
.breadLinks > ul:after { content: ""; display: block; clear: both; }
.breadLinks > ul > li { float: left; border-right: 1px solid #c3c3c3; position: relative; }
.breadLinks ul li strong { color: #B35D5D; margin-left: 4px; }
.breadLinks > ul > li:first-child { border-left: 1px solid #c3c3c3; }
.breadLinks ul li a { color: #666666; padding: 0 12px; display: block; }
.breadLinks ul li a.hasdd { background: url('../assets/images/elements/control/hasddArrow.png') no-repeat 100%; }
.breadLinks ul li a:hover {  
background: #475e7d; }
.breadLinks ul li a span > img { margin-left: 6px; }
.breadLinks ul li ul { position: absolute; display: none; right: -1px; border: 1px solid #c3c3c3; box-shadow: 0 1px 2px #dadada; -webkit-box-shadow: 0 1px 2px #dadada; -moz-box-shadow: 0 1px 2px #dadada; z-index: 990; text-align: left; }
.breadLinks ul li ul, .breadLinks ul li ul li:last-child { -webkit-border-bottom-left-radius: 2px; -webkit-border-bottom-right-radius: 2px; -moz-border-radius-bottomright: 2px;  -moz-border-radius-bottomleft: 2px; }
.breadLinks ul li ul li { width: 140px; float: none; border-top: 1px solid #fff; border-bottom: 1px solid #ddd; }
.breadLinks ul li ul li:first-child { border-top: none; }
.breadLinks ul li ul li a {background: #FDFDFD; padding: 5px 12px;
background: -moz-linear-gradient(top, #FDFDFD 0%, whiteSmoke 100%);
background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,#FDFDFD), color-stop(100%,whiteSmoke));
background: -webkit-linear-gradient(top, #FDFDFD 0%,whiteSmoke 100%);
background: -o-linear-gradient(top, #FDFDFD 0%,whiteSmoke 100%);
background: -ms-linear-gradient(top, #FDFDFD 0%,whiteSmoke 100%);
background: linear-gradient(top, #FDFDFD 0%,whiteSmoke 100%);
filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#fdfdfd', endColorstr='#f5f5f5',GradientType=0 ); }
.breadLinks ul li ul li a:hover { background: #f5f5f5; }
</style>
